<script>
import constants from "@/components/constants";
import commonUtil from "@/components/commonutil";
import server from "@/components/ServerApi";
import LinkTenantSettingAdvancedSettings
    from "@/components/pc/setting/linktenant/LinkTenantSettingAdvancedSettings.vue";
import LinkTenantSettingTemplate from "@/components/pc/setting/linktenant/LinkTenantSettingTemplate.vue";
import LinkTenantSettingListUser from "@/components/pc/setting/linktenant/LinkTenantSettingListUser.vue";
import ListUser from "@/components/pc/setting/linktenant/LinkTenantSettingListUser.vue";
import DeleteObject from "@/components/DeleteObject.vue";
import ConfirmTenantLink from "@/components/pc/setting/linktenant/LinkTenantSettingConfirm.vue";
import AddLinkTenant from "@/components/pc/setting/linktenant/LinkTenantSettingAdd.vue";
import LinkTenantSettingActionLink from "@/components/pc/setting/linktenant/LinkTenantSettingActionLink.vue";
import LinkTenantSettingTable from "@/components/pc/setting/linktenant/LinkTenantSettingTable.vue";
import LinkTenantSettingTitle from "@/components/pc/setting/linktenant/LinkTenantSettingTitle.vue";

const PAGE_SIZES = [
    {v: 10, default: false},
    {v: 20, default: true},
    {v: 50, default: false},
    {v: 100, default: false},
];

export default {
    name: "LinkTenantSetting2",
    emits: ["updateActionRequireTenantCount", "updateConnectedTenantList"],
    components: {
        LinkTenantSettingTitle,
        LinkTenantSettingTable,
        LinkTenantSettingActionLink,
        AddLinkTenant, ConfirmTenantLink,
        ListUser,
        LinkTenantSettingTemplate,
        DeleteLinkTenant: DeleteObject,
        LinkTenantSettingListUser,
        LinkTenantSettingAdvancedSettings
    },
    props: {
        selectedNode: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        appData: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    data() {
        return {
            tenantList: [],
            currentConnectionsCount: 0,
            isTenantAdmin: false,
            pagination: {
                pageSize: PAGE_SIZES.find(p => p.default).v,
                currentPage: 1,
            },
            addLinkTenant: {
                show: false,
                linkType: -1,
            },
            advancedSettings: {
                show: false,
                tenant: undefined,
                linkCategory: -1,
            },
            search: {
                text: "",
            },

            //TODO: 整理したい
            showDeleteLinkTenant: false,
            showConfirmExternalObject: false,
            showConfirmTenantLink: false,
            confirmOnly: false,
            targetTenantId: 0,
            targetType: null,
            deleteTarget: {
                linkType: 0,
                tenant: null,
            },
            targetTenant: null,
            confirmInfo: {
                objectName: null,
                objectTitle: null,
                linkType: 0,
                tenantName: null,
                connect: false,
                allowCheck: false
            },
        };
    },
    computed: {
        pageSizes() {
            return PAGE_SIZES.map(p => p.v);
        },
        remainingConnectionsCount() {
            return Math.max(0, constants.MAX_C2C_CONNECTIONS - this.currentConnectionsCount);
        },
        isTenantLinkLimitReached() {
            return this.remainingConnectionsCount === 0;
        },
        isImportTenantSetting() {
            return this.selectedNode.data.type === constants.SETTING_INTER_COMPANY_IMPORT;
        },
        filteredTenantList() {
            const regexp = new RegExp(RegExp.escape(this.search.text), "i");
            return this.tenantList.filter(t => regexp.test(t.tenantName));
        },
        tenantListForTable() {
            const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
            const end = this.pagination.currentPage * this.pagination.pageSize;
            return this.filteredTenantList.slice(start, end);
        },
    },
    watch: {
        async isImportTenantSetting(newVal) {
            const linkTenants = await this.fetchLinkTenants();
            this.tenantList = newVal ? linkTenants.importTenants : linkTenants.exportTenants;
            this.pagination.currentPage = 1;
            this.search.text = "";
        },
        "search.text"() {
            this.pagination.currentPage = 1;
        },
        "pagination.currentPage"() {
            this.$refs.template?.scrollToTop?.();
        }
    },
    async mounted() {
        const [linkTenants, userRights] = await Promise.all([
            this.fetchLinkTenants(),
            this.fetchUerRights(),
        ]);
        this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
        this.isTenantAdmin = commonUtil.checkUserPrivilege(userRights, constants.PRIVILEGE_TENANT_ADMIN);
    },
    methods: {
        async fetchLinkTenants() {
            try {
                const REQUEST_TENANT_INFO_WITH_DELETED_OR_TERMINATED = 3;
                const res = await server.post('/gettenantconnectinfo', {type: REQUEST_TENANT_INFO_WITH_DELETED_OR_TERMINATED});
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        const actionRequireImportTenantCount = res.data.importTenantList.reduce((acc, t) => {
                            return t.state === constants.TENANT_CONNECT_ALLOW ? acc + 1 : acc;
                        }, 0);
                        const actionRequireExportTenantCount = res.data.exportTenantList.reduce((acc, t) => {
                            return t.state === constants.TENANT_CONNECT_WANT ? acc + 1 : acc;
                        }, 0);
                        this.$emit("updateActionRequireTenantCount", actionRequireImportTenantCount + actionRequireExportTenantCount);

                        this.currentConnectionsCount = [...res.data.importTenantList, ...res.data.exportTenantList]
                            .reduce((acc, t) => t.state === constants.TENANT_CONNECT_ESTABLISH ? acc + 1 : acc, 0);

                        return {
                            importTenants: res.data.importTenantList,
                            exportTenants: res.data.exportTenantList,
                        };
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchLinkTenants").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "fetchLinkTenants", e);
            }
            return {
                importTenants: [],
                exportTenants: [],
            };
        },
        async fetchUerRights() {
            try {
                const res = await server.post("/getinfo", {
                    tenantId: this.appData.tenantList[0].tenantId,
                    id: this.appData.loginUserObjectId,
                    userTalkgroupInfo: false
                });
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        return res.data.rights;
                    case constants.STATUS_ERROR_DENIED:
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_cannot_confirm_link_user"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchUerRights").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "fetchUerRights", e);
            }
            return "";
        },
        async connectTenantRequest(type, tenant) {
            if (!this.isTenantAdmin) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                return;
            }
            await this.connectTenant(
                type === "import" ? constants.TENANT_CONNECT_WANT : constants.TENANT_CONNECT_ALLOW,
                tenant.tenantName,
                1
            );
            this.$emit("updateConnectedTenantList");
        },
        async connectTenant(linkType, tenantName, requestType) {
            this.addLinkTenant.show = false;

            try {
                const res = await server.post('/connecttenant', {
                    linkType: linkType,
                    destinationTenantName: tenantName
                });
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        const linkTenants = await this.fetchLinkTenants();
                        this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
                        if (requestType === 0) {
                            this.confirmInfo.tenantName = tenantName;
                            this.confirmInfo.linkType = linkType;
                            this.confirmInfo.connect = true;
                            this.confirmInfo.allowLink = false;
                            this.showConfirmTenantLink = true;
                        } else {
                            commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_link_connected").replace("{tenantName}", tenantName));
                        }
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_link_tenant_not_found"));
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_link_tenant_already_exist"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                        if (this.remainingConnectionsCount === 0) {
                            commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_exceeds_max_linked_tenants"));
                        } else {
                            commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_the_other_tenant_exceeds_max_linked_tenants"));
                        }
                        break;
                    case constants.STATUS_ERROR_TENANT_ALREADY_DELETED_OR_TERMINATED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_link_tenant_already_deleted_or_terminated"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "connectTenant").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "addLinkTenant", e);
            }
        },
        async disconnectTenantRequest(type, tenant) {
            if (type !== "import" && type !== "export") {
                return;
            }
            if (type === "import") {
                if (!commonUtil.isTenantConnectAdmin(this.appData, tenant.tenantId)) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_operate_no_tenantLinkAdmin"));
                    return;
                }
            }
            if (type === "export") {
                if (!this.isTenantAdmin) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                    return;
                }
            }

            await this.disconnectTenant(
                type === "import" ? constants.TENANT_CONNECT_WANT : constants.TENANT_CONNECT_ALLOW,
                tenant,
                1
            );
            this.$emit("updateConnectedTenantList");
        },
        async allowLinkTenant() {
            this.showConfirmTenantLink = false;
            this.confirmInfo.allowCheck = false;
            await this.connectTenantRequest("export", this.targetTenant)
        },
        cancelConfirmTenantLink() {
            this.showConfirmTenantLink = false;
            this.confirmInfo.allowCheck = false;
        },
        async deleteLinkTenant() {
            await this.disconnectTenant(this.deleteTarget.linkType, this.deleteTarget.tenant, 0);
        },
        async disconnectTenant(linkType, tenant, requestType) {
            this.showDeleteLinkTenant = false;

            try {
                const res = await server.post('/disconnecttenant', {
                    linkType: linkType,
                    destinationTenantId: tenant.tenantId
                });

                switch (res.data.status) {
                    case constants.STATUS_SUCCESS: {
                        const linkTenants = await this.fetchLinkTenants();
                        this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
                        if (requestType === 0) {
                            commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_link_deleted"));
                        } else {
                            this.confirmInfo.tenantName = tenant.tenantName;
                            this.confirmInfo.linkType = linkType;
                            this.confirmInfo.connect = false;
                            this.showConfirmTenantLink = true;
                        }
                        break;
                    }
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                        break;
                    case constants.STATUS_ERROR_USER_EXISTS:
                        if (linkType === constants.TENANT_CONNECT_WANT) {
                            this.deleteTarget.linkType = linkType;
                            this.deleteTarget.tenant = tenant;
                            this.targetTenantId = tenant.tenantId;
                            this.targetType = "import";
                            this.confirmOnly = false;
                            this.showConfirmExternalObject = true;
                        } else {
                            commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_disconnect_link_exit_user"));
                        }
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND: {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_link_already_deleted"));
                        const linkTenants = await this.fetchLinkTenants();
                        this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
                        break;
                    }
                    case constants.STATUS_ERROR_TOO_MANY_DELETE_USERS:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_too_many_delete_users"))
                        break;
                    case constants.STATUS_ERROR_ALREADY_CHANGE_STATUS: {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_already_change_status"))
                        const linkTenants = await this.fetchLinkTenants();
                        this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
                        break;
                    }
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "disconnectTenant").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "deleteLinkTenant", e);
            }
        },
        async disconnectAfterRemove(userTalkgroups) {
            this.showConfirmExternalObject = false;

            const operations = userTalkgroups.map(u => ({
                command: "removefromtalkgroup",
                operation: {
                    tenantId: u.talkgroupTenantId,
                    talkgroupId: u.talkgroupId,
                    userTenantId: u.userTenantId,
                    userId: u.userId
                },
            }));
            try {
                const res = await server.post('/multiop', {operations: operations});
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        await this.disconnectTenant(this.deleteTarget.linkType, this.deleteTarget.tenant, 1)
                        break;
                    case constants.STATUS_ERROR_BATCH_PROCESS:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_link_user_delete_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "disconnectAfterRemove").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "disconnectAfterRemove", e);
            }
        },
        handleLinkTenantAddRequest() {
            this.showAddLinkTenantDialog(this.isImportTenantSetting ? 'import' : 'export');
        },
        showAddLinkTenantDialog(type) {
            if (!this.isTenantAdmin) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                return;
            }
            this.addLinkTenant = {
                show: true,
                linkType: type === "import"
                    ? constants.TENANT_CONNECT_WANT
                    : constants.TENANT_CONNECT_ALLOW,
            };
        },
        showDeleteLinkTenantDialog(type, linkTenant) {
            if (!this.isTenantAdmin) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                return;
            }
            this.deleteTarget.tenant = linkTenant;
            this.confirmInfo.objectName = linkTenant.tenantName;
            switch (type) {
                case "import":
                    this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_desc_link_tenant1");
                    this.deleteTarget.linkType = constants.TENANT_CONNECT_WANT;
                    break;
                case "export":
                    this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_desc_link_tenant2");
                    this.deleteTarget.linkType = constants.TENANT_CONNECT_ALLOW;
                    break;
                case "importForceUnLink":
                    this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_desc_link_tenant1");
                    this.deleteTarget.linkType = constants.TENANT_CONNECT_IMPORT_FORCE_UNLINK;
                    break;
                case "exportForceUnLink":
                    this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_desc_link_tenant2");
                    this.deleteTarget.linkType = constants.TENANT_CONNECT_EXPORT_FORCE_UNLINK;
                    break;
                default:
                    return;
            }
            this.showDeleteLinkTenant = true;
        },
        showConfirmGroupAndUser(type, tenant) {
            if (!this.isTenantAdmin) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                return;
            }
            this.confirmOnly = true;
            this.targetType = type;
            this.targetTenantId = tenant.tenantId;
            this.showConfirmExternalObject = true;
        },
        checkPerformAllowLink(linkTenant) {
            if (!this.isTenantAdmin) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                return;
            }
            this.targetTenant = linkTenant;
            this.confirmInfo.tenantName = linkTenant.tenantName;
            this.confirmInfo.linkType = constants.TENANT_CONNECT_ALLOW;
            this.confirmInfo.connect = true;
            this.confirmInfo.allowCheck = true;
            this.showConfirmTenantLink = true;
        },
        openAdvancedSettings(linkTenant) {
            if (this.isImportTenantSetting) {
                if (!commonUtil.isTenantConnectAdmin(this.appData, linkTenant.tenantId)) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_operate_no_tenantLinkAdmin"));
                    return;
                }
            } else {
                if (!this.isTenantAdmin) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_insufficient_permissions_tenant_or_root"));
                    return;
                }
            }
            this.advancedSettings = {
                show: true,
                tenant: linkTenant,
                linkCategory: this.isImportTenantSetting
                    ? constants.LINK_CATEGORY.IMPORT
                    : constants.LINK_CATEGORY.EXPORT,
            };
        },
        async saveAdvancedSettings(newSettings) {
            this.advancedSettings.show = false;
            if (this.advancedSettings.linkCategory === constants.LINK_CATEGORY.EXPORT) {
                await this.saveExportTenantAdvancedSettings(newSettings);
            } else if (this.advancedSettings.linkCategory === constants.LINK_CATEGORY.IMPORT) {
                await this.saveImportTenantAdvancedSettings(newSettings);
            }
        },
        async saveExportTenantAdvancedSettings(newSettings) {
            const payload = {
                linkTenantId: this.advancedSettings.tenant.tenantId,
                newC2COption: newSettings,
            };
            try {
                const res = await server.post('/modifyexporttenantc2coption', payload);
                await this.handleSaveAdvancedSettingsResponse(res, "saveExportTenantAdvancedSettings");
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "modifyexporttenantc2coption", e);
            }
        },
        async saveImportTenantAdvancedSettings(newSettings) {
            const payload = {
                linkTenantId: this.advancedSettings.tenant.tenantId,
                newC2COption: newSettings,
            };
            try {
                const res = await server.post('/modifyimporttenantc2coption', payload);
                await this.handleSaveAdvancedSettingsResponse(res, "saveImportTenantAdvancedSettings");
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "modifyimporttenantc2coption", e);
            }
        },
        async handleSaveAdvancedSettingsResponse(response, functionName) {
            switch (response.data.status) {
                case constants.STATUS_SUCCESS: {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_link_c2c_option_modified"));
                    const linkTenants = await this.fetchLinkTenants();
                    this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
                    break;
                }
                case constants.STATUS_ERROR_DENIED:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_link_cannot_edit_advanced_settings_without_established_connection"));
                    break;
                case constants.STATUS_ERROR_NOT_FOUND: {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_link_already_deleted"));
                    const linkTenants = await this.fetchLinkTenants();
                    this.tenantList = this.isImportTenantSetting ? linkTenants.importTenants : linkTenants.exportTenants;
                    break;
                }
                case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_tenant_already_deleted"));
                    break;
                default:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", `${functionName}`).replace("{code}", response.data.status));
                    break;
            }
        },
    },
}
</script>

<template>
    <LinkTenantSettingTemplate ref="template">
        <template v-slot:title>
            <LinkTenantSettingTitle
                @linkTenantAddRequest="handleLinkTenantAddRequest"
                :settingType="selectedNode.data.type"
                :currentConnectionsCount="currentConnectionsCount"
            />
        </template>
        <template v-slot:search>
            <div class="link-tenant-setting__search">
                <el-input
                    v-model.trim="search.text"
                    :placeholder="$t('message.action_search_items_by_tenant_name')"
                    class="link-tenant-setting__search-text"
                    prefix-icon="el-icon-search"
                    clearable
                ></el-input>
            </div>
        </template>
        <template v-slot:tenant-list>
            <LinkTenantSettingTable
                @connectRequest="connectTenantRequest"
                @disconnectRequest="disconnectTenantRequest"
                @confirmAllowRequest="checkPerformAllowLink"
                @deleteLinkRequest="showDeleteLinkTenantDialog"
                @listGroupAndUserRequest="showConfirmGroupAndUser"
                @advancedSettingsRequest="openAdvancedSettings"
                :myTenantName="appData?.tenantList?.[0]?.name ?? ''"
                :tenantList="tenantListForTable"
                :settingType="selectedNode.data.type"
                :isTenantLinkLimitReached="isTenantLinkLimitReached"
            />
        </template>
        <template v-slot:pagination>
            <el-pagination
                v-if="tenantList.length > 0"
                :pageSizes="pageSizes"
                :pageSize.sync="pagination.pageSize"
                :currentPage.sync="pagination.currentPage"
                :total="filteredTenantList.length"
                class="tenant-list-pagination"
                layout="prev, pager, next, sizes, total"
                background
            ></el-pagination>
        </template>
        <template v-slot:modals>
            <AddLinkTenant
                v-if="addLinkTenant.show"
                :linkType="addLinkTenant.linkType"
                :appData='appData'
                @cancel="addLinkTenant.show=false"
                @save="connectTenant"
            />
            <DeleteLinkTenant
                v-if="showDeleteLinkTenant"
                :confirmInfo="confirmInfo"
                @cancel="showDeleteLinkTenant=false"
                @delete="deleteLinkTenant"
            />
            <ListUser
                v-if="showConfirmExternalObject"
                :appData="appData"
                :tenantId="targetTenantId"
                :type="targetType"
                :confirmOnly="confirmOnly"
                @ok="showConfirmExternalObject=false"
                @cancel="showConfirmExternalObject=false"
                @save="disconnectAfterRemove"
            />
            <ConfirmTenantLink
                v-if="showConfirmTenantLink"
                :confirmInfo="confirmInfo"
                @allowLink="allowLinkTenant()"
                @confirm="showConfirmTenantLink=false"
                @cancel="cancelConfirmTenantLink()"
            />
            <LinkTenantSettingAdvancedSettings
                v-if="advancedSettings.show"
                :targetTenant="advancedSettings.tenant"
                :linkCategory="advancedSettings.linkCategory"
                @cancel="advancedSettings.show=false"
                @save="saveAdvancedSettings"
            />
        </template>
    </LinkTenantSettingTemplate>
</template>

<style scoped>
* {
    box-sizing: border-box;
}

.link-tenant-setting__search {
    background-color: #f6f6f6;
    padding: 0 20px;

    .link-tenant-setting__search-text {
        width: 240px;
    }
}

.tenant-list-pagination {
    padding: 16px 0;
}

.tenant-list-pagination >>> .el-input {
    width: 120px;
}

</style>
